export const ADD_USER = 'ADD_USER';
export const SET_ACTIVE = 'SET_ACTIVE';
export const GET_TRIVIA = 'GET_TRIVIA';
export const ADD_POINTS = 'ADD_POINTS';
export const ADD_TASK = 'ADD_TASK';
export const COMPLETE_TASK = 'COMPLETE_TASK';
export const CLEAR_TASKS = 'CLEAR_TASKS';